/* rola.pet — logika kalkulatorów. Plik generowany przez build-theme.js.
   Zero zależności, zero zapytań sieciowych. Inicjalizuje się sam po DOMContentLoaded. */
(function(){
  function boot(){
    /* ---------- KALKULATOR WIEKU ---------- */
    (function(){
      "use strict";

      /* ---------- dane ---------- */

      // Tabela odpowiedników wieku (AVMA) — pełne lata 1..15
      var TABLE = {
        maly:   {1:15,2:24,3:28,4:32,5:36,6:40,7:44,8:48,9:52,10:56,11:60,12:64,13:68,14:72,15:76},
        sredni: {1:15,2:24,3:28,4:32,5:36,6:42,7:47,8:51,9:56,10:60,11:65,12:69,13:74,14:78,15:83},
        duzy:   {1:15,2:24,3:28,4:32,5:36,6:45,7:50,8:55,9:61,10:66,11:72,12:77,13:82,14:88,15:93}
      };
      // przyrost roczny powyżej 15 lat
      var TAIL = {maly:4, sredni:5, duzy:5.5};
      // wiek 6 miesięcy
      var HALF = 10;

      var SIZE_LIFESPAN = {maly:15, sredni:13, duzy:11};
      var SIZE_LABEL = {maly:"mały pies", sredni:"średni pies", duzy:"duży pies"};

      // rasa: [nazwa, wielkość, przewidywana długość życia]
      var BREEDS = [
        ["Akita",'duzy',11],["Alaskan malamute",'duzy',11],["Amstaff",'duzy',13],
        ["Basset hound",'sredni',12],["Beagle",'sredni',13],["Berneński pies pasterski",'duzy',8],
        ["Bichon frisé",'maly',15],["Bokser",'duzy',10],["Border collie",'sredni',13],
        ["Boston terrier",'maly',13],["Buldog angielski",'sredni',9],["Buldog francuski",'sredni',11],
        ["Bullterrier",'sredni',12],["Cavalier king charles spaniel",'maly',12],
        ["Chihuahua",'maly',16],["Chow chow",'sredni',11],["Cocker spaniel",'sredni',13],
        ["Collie (owczarek szkocki)",'duzy',13],["Dalmatyńczyk",'duzy',12],["Doberman",'duzy',11],
        ["Dog niemiecki",'duzy',8],["Golden retriever",'duzy',12],["Husky syberyjski",'sredni',13],
        ["Jack russell terrier",'maly',15],["Jamnik",'maly',14],["Kundelek / mieszaniec",'sredni',13],
        ["Labrador retriever",'duzy',12],["Maltańczyk",'maly',14],["Mastif",'duzy',9],
        ["Mops",'maly',13],["Nowofundland",'duzy',9],["Owczarek australijski",'sredni',13],
        ["Owczarek belgijski (malinois)",'duzy',12],["Owczarek niemiecki",'duzy',11],
        ["Owczarek podhalański",'duzy',11],["Pinczer miniaturowy",'maly',14],
        ["Pomeranian (szpic miniaturowy)",'maly',15],["Pudel duży (królewski)",'duzy',12],
        ["Pudel miniaturowy",'maly',15],["Pudel średni",'sredni',14],["Rottweiler",'duzy',10],
        ["Samojed",'sredni',12],["Setter irlandzki",'duzy',12],["Sheltie",'maly',13],
        ["Shiba inu",'sredni',14],["Shih tzu",'maly',14],["Springer spaniel",'sredni',13],
        ["Sznaucer miniaturowy",'maly',14],["Sznaucer olbrzym",'duzy',11],["Sznaucer średni",'sredni',13],
        ["Terier szkocki",'maly',13],["Weimaraner",'duzy',12],
        ["West highland white terrier",'maly',14],["Whippet",'sredni',13],
        ["Wyżeł niemiecki krótkowłosy",'duzy',13],["Yorkshire terrier",'maly',15]
      ];

      // rasy pokazywane na górze listy, gdy pole jest puste
      var POPULAR = ["Labrador retriever","Owczarek niemiecki","Golden retriever","Border collie",
        "Jamnik","Yorkshire terrier","Buldog francuski","Mops","Beagle","Kundelek / mieszaniec"];

      // etapy wg ułamka przeżytego życia
      var STAGES = [
        {key:'szczenie', max:.08, name:"Szczenię", sub:"intensywny wzrost",
         comment:"Szczeniak w pełnym rozkwicie — to najważniejsze miesiące na socjalizację i naukę. Wszystko, czego nauczy się teraz, zostanie z nim na lata.",
         care:["Socjalizacja: nowi ludzie, psy, dźwięki, powierzchnie — spokojnie i w małych dawkach","Karma dla szczeniąt i 3–4 posiłki dziennie zamiast dwóch","Pełny cykl szczepień i odrobaczanie zgodnie z zaleceniem lekarza","Nauka samotności od pierwszych dni — zapobiega lękowi separacyjnemu","Bez długich biegów i skoków — stawy i płytki wzrostowe wciąż się rozwijają"]},
        {key:'junior', max:.16, name:"Junior", sub:"wiek dojrzewanie",
         comment:"Młody dorosły — pełen energii i gotowy na przygody. To też wiek, w którym psy „testują granice”, więc konsekwencja popłaca.",
         care:["Stopniowe przejście na karmę dla dorosłych psów (u dużych ras około 12.–18. miesiąca)","Rozmowa z lekarzem o kastracji lub sterylizacji i o jej wpływie na zapotrzebowanie kaloryczne","Regularny trening i dużo aktywności — nadmiar energii szuka ujścia","Pierwsze czyszczenie zębów i wdrożenie codziennej higieny jamy ustnej","Kontrola masy ciała — po sterylizacji zapotrzebowanie spada nawet o 25%"]},
        {key:'dorosly', max:.60, name:"Dorosły", sub:"pełnia sił",
         comment:"W sile wieku — stabilny, pewny siebie, najlepszy przyjaciel. Teraz najbardziej opłaca się profilaktyka: to, co zrobisz dziś, zobaczysz za pięć lat.",
         care:["Wizyta kontrolna raz w roku, nawet gdy nic się nie dzieje","Utrzymanie prawidłowej masy ciała — nadwaga skraca życie psa średnio o około 2 lata","Codzienna higiena zębów; kamień nazębny obciąża serce i nerki","Regularna profilaktyka przeciwkleszczowa i przeciwpasożytnicza","Aktywność umysłowa: węszenie, mata węchowa, nowe komendy"]},
        {key:'senior', max:.85, name:"Senior", sub:"czas na profilaktykę",
         comment:"Dojrzały pan lub dojrzała pani — zasługuje na więcej odpoczynku, wygodne legowisko i częstsze wizyty u weterynarza.",
         care:["Badania kontrolne co 6 miesięcy, w tym morfologia, biochemia i badanie moczu","Obserwuj sztywność po wstaniu i niechęć do schodów — to zwykle początek zmian stawowych","Rozważ karmę dla seniorów oraz suplementy na stawy po konsultacji z lekarzem","Krótsze, ale częstsze spacery zamiast jednego długiego marszu","Kontroluj wagę: spadek bez zmiany diety zawsze wymaga diagnostyki"]},
        {key:'sedziwy', max:2, name:"Sędziwy", sub:"szczególna troska",
         comment:"Prawdziwy jubilat! Otocz go wyjątkową troską każdego dnia — komfort jest teraz ważniejszy niż forma.",
         care:["Kontrola weterynaryjna co 4–6 miesięcy plus badanie ciśnienia i serca","Maty antypoślizgowe i podjazdy — poślizgnięcia są główną przyczyną urazów u starych psów","Obserwuj zmiany zachowania w nocy: mogą wskazywać na zespół dysfunkcji poznawczych","Dieta łatwostrawna, o odpowiedniej kaloryczności i wysokiej jakości białku","Utrzymuj stały rytm dnia — przewidywalność obniża stres u seniorów"]}
      ];

      /* ---------- logika ---------- */

      function humanAge(dogYears, size){
        var t = TABLE[size];
        if(dogYears <= 0.5) return HALF;
        if(dogYears < 1) return HALF + (t[1] - HALF) * ((dogYears - .5) / .5);
        if(dogYears >= 15) return t[15] + (dogYears - 15) * TAIL[size];
        var lo = Math.floor(dogYears), hi = lo + 1;
        return t[lo] + (t[hi] - t[lo]) * (dogYears - lo);
      }

      function stageFor(frac){
        for(var i=0;i<STAGES.length;i++) if(frac <= STAGES[i].max) return STAGES[i];
        return STAGES[STAGES.length-1];
      }

      function plYears(n){
        // poprawna polska odmiana: 1 rok, 2–4 lata, 5+ lat
        var v = Math.round(n*10)/10;
        var whole = Math.round(v);
        if(Math.abs(v - whole) > 0.001) return "lata"; // 1,5 roku -> używamy osobno
        var last = whole % 10, last2 = whole % 100;
        if(whole === 1) return "rok";
        if(last >= 2 && last <= 4 && !(last2 >= 12 && last2 <= 14)) return "lata";
        return "lat";
      }
      function plHumanYears(n){
        var last = n % 10, last2 = n % 100;
        if(n === 1) return "ludzki rok";
        if(last >= 2 && last <= 4 && !(last2 >= 12 && last2 <= 14)) return "ludzkie lata";
        return "ludzkich lat";
      }
      function fmt(n){ return String(n).replace(".", ","); }

      /* ---------- render ---------- */

      function init(root){
        var $ = function(s){ return root.querySelector(s); };
        var $$ = function(s){ return Array.prototype.slice.call(root.querySelectorAll(s)); };

        var slider = $("[data-in-age]");
        var num = $("[data-in-age-num]");
        var breedInput = $("[data-in-breed]");
        var result = $("[data-result]");
        var shown = false;
        var currentDisplay = 0;
        var raf = null;

        function selectedSize(){
          var on = $$('input[type=radio]').filter(function(r){ return r.checked; })[0];
          return on ? on.value : "sredni";
        }

        function findBreed(){
          var v = (breedInput && breedInput.value || "").trim().toLowerCase();
          if(!v) return null;
          for(var i=0;i<BREEDS.length;i++){
            if(BREEDS[i][0].toLowerCase() === v) return BREEDS[i];
          }
          for(var j=0;j<BREEDS.length;j++){
            if(BREEDS[j][0].toLowerCase().indexOf(v) === 0) return BREEDS[j];
          }
          for(var k=0;k<BREEDS.length;k++){
            if(BREEDS[k][0].toLowerCase().indexOf(v) !== -1) return BREEDS[k];
          }
          return null;
        }

        /* ---------------- combobox rasy ---------------- */
        var comboList = $("[data-combo-list]");
        var comboClear = $("[data-combo-clear]");
        var comboToggle = $("[data-combo-toggle]");
        var comboOpts = [];
        var comboIdx = -1;

        var SIZE_SHORT = {maly:"do 10 kg", sredni:"10–25 kg", duzy:"ponad 25 kg"};

        function byName(n){
          for(var i=0;i<BREEDS.length;i++) if(BREEDS[i][0] === n) return BREEDS[i];
          return null;
        }

        function buildCombo(){
          var q = (breedInput.value || "").trim().toLowerCase();
          comboList.innerHTML = "";
          comboOpts = [];
          comboIdx = -1;

          var groups;
          if(!q){
            var pop = POPULAR.map(byName).filter(Boolean);
            var rest = BREEDS.filter(function(b){ return POPULAR.indexOf(b[0]) === -1; });
            groups = [["Najpopularniejsze", pop], ["Wszystkie rasy (A–Z)", rest]];
          } else {
            var starts = [], inside = [];
            BREEDS.forEach(function(b){
              var n = b[0].toLowerCase();
              if(n.indexOf(q) === 0) starts.push(b);
              else if(n.indexOf(q) !== -1) inside.push(b);
            });
            groups = [["", starts.concat(inside)]];
          }

          groups.forEach(function(g){
            if(!g[1].length) return;
            if(g[0]){
              var h = document.createElement("li");
              h.className = "rc-combo-group";
              h.setAttribute("role", "presentation");
              h.textContent = g[0];
              comboList.appendChild(h);
            }
            g[1].forEach(function(b){
              var li = document.createElement("li");
              li.className = "rc-combo-opt";
              li.setAttribute("role", "option");
              li.setAttribute("aria-selected", "false");
              var nm = document.createElement("span");
              nm.textContent = b[0];
              var meta = document.createElement("small");
              meta.textContent = SIZE_SHORT[b[1]] + " · ~" + b[2] + " lat";
              li.appendChild(nm);
              li.appendChild(meta);
              li.addEventListener("mousedown", function(e){ e.preventDefault(); pickBreed(b[0]); });
              comboList.appendChild(li);
              comboOpts.push(li);
            });
          });

          if(!comboOpts.length){
            var em = document.createElement("li");
            em.className = "rc-combo-empty";
            em.setAttribute("role", "presentation");
            em.textContent = "Nie znaleziono takiej rasy. Zostaw pole puste — do przeliczenia wieku wystarczy wybrana wielkość psa.";
            comboList.appendChild(em);
          }
        }

        function openCombo(){
          buildCombo();
          comboList.hidden = false;
          breedInput.setAttribute("aria-expanded", "true");
        }
        function closeCombo(){
          comboList.hidden = true;
          breedInput.setAttribute("aria-expanded", "false");
          highlight(-1);
        }
        function highlight(i){
          comboOpts.forEach(function(el, n){
            var on = n === i;
            el.classList.toggle("is-active", on);
            el.setAttribute("aria-selected", on ? "true" : "false");
          });
          comboIdx = i;
          if(i >= 0 && comboOpts[i]){
            var el = comboOpts[i];
            var top = el.offsetTop, bottom = top + el.offsetHeight;
            if(top < comboList.scrollTop) comboList.scrollTop = top - 6;
            else if(bottom > comboList.scrollTop + comboList.clientHeight) comboList.scrollTop = bottom - comboList.clientHeight + 6;
          }
        }
        function pickBreed(name){
          breedInput.value = name;
          closeCombo();
          syncBreed();
          // focus zostaje na polu (mousedown + preventDefault), więc go nie ustawiamy —
          // inaczej handler focus otworzyłby listę z powrotem
        }
        function syncBreed(){
          var b = findBreed();
          comboClear.hidden = !(breedInput.value || "").trim();
          if(b){
            var radio = root.querySelector('input[type=radio][value="' + b[1] + '"]');
            if(radio && !radio.checked){
              radio.checked = true;
              $$(".rc-opt").forEach(function(o){ o.classList.remove("is-on"); });
              radio.closest(".rc-opt").classList.add("is-on");
            }
          }
          render();
        }

        function animateNumber(el, to){
          if(raf) cancelAnimationFrame(raf);
          var from = currentDisplay, start = null, dur = 420;
          if(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches){
            currentDisplay = to; el.textContent = to; return;
          }
          function step(ts){
            if(start === null) start = ts;
            var p = Math.min(1, (ts - start) / dur);
            var e = 1 - Math.pow(1 - p, 3);
            var v = Math.round(from + (to - from) * e);
            el.textContent = v;
            if(p < 1) raf = requestAnimationFrame(step); else currentDisplay = to;
          }
          raf = requestAnimationFrame(step);
        }

        var scope = root.closest("[data-rc-scope]") || root.parentNode;

        function publish(params, stageName){
          if(!scope || !scope.setAttribute) return;
          try { scope.setAttribute("data-rc-params", JSON.stringify(params)); } catch(e){}
          var slots = scope.querySelectorAll("[data-rc-stage-name]");
          for(var i=0;i<slots.length;i++) slots[i].textContent = stageName;
          scope.setAttribute("data-rc-stage", stageName);
        }

        function paintSlider(){
          var mn = parseFloat(slider.min), mx = parseFloat(slider.max);
          var p = ((parseFloat(slider.value) - mn) / (mx - mn)) * 100;
          slider.style.background =
            "linear-gradient(90deg, var(--rc-accent) 0 " + p.toFixed(2) + "%, var(--rc-track) " + p.toFixed(2) + "% 100%)";
        }

        function render(){
          paintSlider();
          var size = selectedSize();
          var breed = findBreed();
          var age = parseFloat(slider.value);

          var human = Math.round(humanAge(age, size));
          var lifespan = breed ? breed[2] : SIZE_LIFESPAN[size];
          var frac = age / lifespan;
          var stage = stageFor(frac);
          var left = Math.max(0, lifespan - age);

          animateNumber($("[data-human]"), human);
          $("[data-human-unit]").textContent = plHumanYears(human);

          var who = breed ? "Twój " + breed[0].toLowerCase().split(" (")[0] : "Twój " + SIZE_LABEL[size];
          var ageTxt = (age % 1 === 0) ? fmt(age) + " " + plYears(age) : fmt(age) + " roku";
          $("[data-headline]").innerHTML =
            who + " w wieku <b>" + ageTxt + "</b> ma odpowiednik <b>" + human + " " + plHumanYears(human) + "</b> 🎂";

          // oś życia
          var pct = Math.max(0, Math.min(100, frac * 100));
          $("[data-marker]").style.left = pct.toFixed(1) + "%";

          // kafelki
          $("[data-stage]").textContent = stage.name;
          $("[data-stage-sub]").textContent = stage.sub;

          $("[data-lifespan]").textContent = "~" + lifespan + " " + plYears(lifespan);
          $("[data-lifespan-sub]").textContent = breed
            ? "średnia dla rasy " + breed[0].split(" (")[0].toLowerCase()
            : "średnia dla psów tej wielkości";

          if(left <= 0){
            $("[data-left]").textContent = "bonus 🎉";
            $("[data-left-sub]").textContent = "Twój pies przekroczył statystyczną średnią — każdy kolejny dzień to nagroda za dobrą opiekę.";
          } else {
            var leftR = Math.round(left * 10) / 10;
            $("[data-left]").textContent = "~" + fmt(leftR) + " " + (leftR % 1 === 0 ? plYears(leftR) : "roku");
            $("[data-left-sub]").textContent = "za sobą " + Math.round(frac * 100) + "% statystycznego życia";
          }

          $("[data-tl-caption]").innerHTML =
            "Etap: <b>" + stage.name + "</b> · " +
            (left <= 0 ? "powyżej statystycznej średniej"
                       : "za sobą <b>" + Math.round(frac * 100) + "%</b> statystycznego życia");

          $("[data-comment]").textContent = stage.comment;

          var ul = $("[data-care]");
          ul.innerHTML = "";
          stage.care.forEach(function(txt){
            var li = document.createElement("li");
            li.textContent = txt;
            ul.appendChild(li);
          });
          $("[data-acc-care] summary").firstChild.nodeValue =
            "Na co zwrócić uwagę na etapie „" + stage.name + "”";

          publish({
            kalkulator: "wiek_psa",
            wielkosc_psa: SIZE_LABEL[size],
            rasa: breed ? breed[0] : "",
            wiek_psa_lata: age,
            wiek_w_ludzkich_latach: human,
            etap_zycia: stage.name,
            przewidywana_dlugosc_zycia: lifespan
          }, stage.name);

          if(!shown){ shown = true; requestAnimationFrame(function(){ result.classList.add("is-in"); }); }
        }

        // synchronizacja suwak <-> pole
        function setAge(v){
          v = Math.min(20, Math.max(0.5, Math.round(v * 2) / 2));
          slider.value = v; num.value = fmt(v); render();
        }
        // pole tekstowe z przecinkiem — polski zapis dziesiętny
        function readNum(el){
          var v = parseFloat(String(el.value).replace(",", ".").replace(/\s/g, ""));
          return isNaN(v) ? null : v;
        }
        slider.addEventListener("input", function(){ num.value = fmt(slider.value); render(); });
        num.addEventListener("input", function(){
          var v = readNum(num);
          if(v !== null){ slider.value = Math.min(20, Math.max(0.5, v)); render(); }
        });
        num.addEventListener("blur", function(){
          var v = readNum(num);
          setAge(v === null ? 3 : v);
          num.value = fmt(slider.value);
        });

        $$('input[type=radio]').forEach(function(r){
          r.addEventListener("change", function(){
            $$(".rc-opt").forEach(function(o){ o.classList.remove("is-on"); });
            r.closest(".rc-opt").classList.add("is-on");
            render();
          });
        });

        /* --- zdarzenia comboboxa --- */
        breedInput.addEventListener("focus", openCombo);
        breedInput.addEventListener("click", function(){ if(comboList.hidden) openCombo(); });
        breedInput.addEventListener("input", function(){ openCombo(); syncBreed(); });
        breedInput.addEventListener("keydown", function(e){
          if(e.key === "ArrowDown"){
            e.preventDefault();
            if(comboList.hidden) openCombo();
            highlight(Math.min(comboOpts.length - 1, comboIdx + 1));
          } else if(e.key === "ArrowUp"){
            e.preventDefault();
            highlight(Math.max(0, comboIdx - 1));
          } else if(e.key === "Enter"){
            if(!comboList.hidden && comboOpts.length){
              e.preventDefault();
              var el = comboOpts[comboIdx >= 0 ? comboIdx : 0];
              pickBreed(el.firstChild.textContent);
            }
          } else if(e.key === "Escape"){
            if(!comboList.hidden){ e.stopPropagation(); closeCombo(); }
          } else if(e.key === "Tab"){
            closeCombo();
          }
        });
        comboToggle.addEventListener("click", function(){
          if(comboList.hidden){ breedInput.focus(); openCombo(); } else closeCombo();
        });
        comboClear.addEventListener("click", function(){
          breedInput.value = "";
          closeCombo();
          syncBreed();
          breedInput.focus();
        });
        document.addEventListener("click", function(e){
          if(!root.contains(e.target) || !e.target.closest("[data-combo]")) closeCombo();
        });

        /* --- panele ⓘ --- */
        $$("[data-info-toggle]").forEach(function(btn){
          var key = btn.getAttribute("data-info-toggle");
          var panel = root.querySelector('[data-info-panel="' + key + '"]');
          if(!panel) return;
          btn.addEventListener("click", function(){
            var open = btn.getAttribute("aria-expanded") === "true";
            btn.setAttribute("aria-expanded", open ? "false" : "true");
            panel.hidden = open;
          });
        });

        syncBreed();
        render();
      }

      var nodes = document.querySelectorAll("[data-rola-dog-age]");
      for(var i=0;i<nodes.length;i++){
        if(nodes[i].getAttribute("data-rc-init")) continue;
        nodes[i].setAttribute("data-rc-init","1");
        init(nodes[i]);
      }
    })();
    /* ---------- KALKULATOR KARMIENIA ---------- */
    (function(){
      "use strict";

      var TYPES = [
        {k:"szcz04",  f:3.0, emoji:"🍼", name:"Szczeniak 0–4 mies.",    desc:"okres najszybszego wzrostu",
         note:"Szczeniaki rosną błyskawicznie i mają maleńkie żołądki — rozłóż porcję na 4 posiłki dziennie. Przelicz porcję ponownie za każdym razem, gdy pies przybierze około 10% wagi."},
        {k:"szcz412", f:2.0, emoji:"🐶", name:"Szczeniak 4 mies.–1 rok", desc:"dorastanie i wyciszanie wzrostu",
         note:"W tym wieku zapotrzebowanie zaczyna spadać, a apetyt zostaje ten sam. Zmniejszaj porcję stopniowo i przejdź na 2–3 posiłki dziennie."},
        {k:"malo",    f:1.2, emoji:"🛋️", name:"Dorosły — mało aktywny", desc:"krótkie spacery, dużo leżenia",
         note:"Przy niskiej aktywności margines błędu jest mały — kilkadziesiąt kalorii ponad normę dziennie to kilka kilogramów w skali roku. Waż psa raz w miesiącu."},
        {k:"kastr",   f:1.6, emoji:"✂️", name:"Dorosły — kastrowany",   desc:"po zabiegu, umiarkowany ruch",
         note:"Po kastracji zapotrzebowanie energetyczne spada nawet o 20–30%, a apetyt często rośnie. To najczęstszy moment, w którym psy tyją — kontroluj wagę co 2 tygodnie przez pierwsze pół roku."},
        {k:"aktywny", f:1.8, emoji:"🎾", name:"Dorosły — aktywny",      desc:"2× dziennie po 45 minut",
         note:"Solidna baza dla zdrowego, ruchliwego psa. Pamiętaj, że zimą i przy pracy w terenie zapotrzebowanie rośnie dodatkowo o 10–20%."},
        {k:"sport",   f:3.0, emoji:"🏃", name:"Bardzo aktywny (sport)",  desc:"agility, canicross, praca",
         note:"Psy sportowe potrzebują nie tylko więcej kalorii, ale też innych proporcji — więcej tłuszczu jako paliwa wytrzymałościowego. Nie karm obficie na godzinę przed wysiłkiem."},
        {k:"dieta",   f:1.0, emoji:"⚖️", name:"Pies na diecie",         desc:"redukcja nadwagi",
         note:"Wylicz porcję dla wagi docelowej, nie aktualnej. Bezpieczne tempo to 1–2% masy ciała tygodniowo, a cała kuracja powinna trwać minimum 8–12 tygodni pod kontrolą weterynarza."},
        {k:"senior",  f:1.1, emoji:"🦴", name:"Senior",                  desc:"spokojniejszy tryb życia",
         note:"Starsze psy potrzebują mniej kalorii, ale więcej wysokiej jakości białka — obniżanie białka „dla nerek” u zdrowego seniora to mit. Rozważ karmę dla seniorów i podziel dzienną porcję na 3 mniejsze posiłki."}
      ];

      /* ---------- sposób karmienia ---------- */
      var PART = {
        dry:  {name:"Karma sucha",    short:"karma sucha"},
        wet:  {name:"Karma mokra",    short:"karma mokra"},
        home: {name:"Domowe posiłki", short:"domowe posiłki"}
      };

      var FEEDS = [
        {k:"dry",      emoji:"\ud83e\udd63", name:"Tylko sucha karma", desc:"jeden rodzaj karmy",             parts:["dry"]},
        {k:"dry_wet",  emoji:"\ud83e\udd6b", name:"Sucha + mokra",     desc:"karma sucha z dodatkiem mokrej", parts:["dry","wet"]},
        {k:"dry_home", emoji:"\ud83c\udf72", name:"Sucha + domowe",    desc:"karma sucha i gotowane posiłki", parts:["dry","home"]},
        {k:"wet_home", emoji:"\ud83c\udf57", name:"Mokra + domowe",    desc:"karma mokra i gotowane posiłki", parts:["wet","home"]},
        {k:"home",     emoji:"\ud83c\udf73", name:"Tylko domowe",      desc:"gotujesz samodzielnie",          parts:["home"]},
        {k:"all_three", emoji:"\ud83e\udde9", name:"Wszystkie trzy",   desc:"sucha + mokra + domowe",         parts:["dry","wet","home"], demand:true}
      ];

      /* udział DRUGIEGO składnika w dziennych kaloriach */
      var SHARES = [
        {v:25, name:"Jako dodatek", desc:"około ćwierci kalorii"},
        {v:50, name:"Pół na pół",   desc:"około połowy kalorii"},
        {v:75, name:"Głównie to",   desc:"około trzech czwartych"}
      ];

      /* domowe posiłki — przedziały kaloryczności na 100 g */
      var HOMES = [
        {k:"lean",  emoji:"\ud83c\udf57", name:"Głównie mięso, chude", desc:"kurczak, indyk, serca, chuda wołowina", min:120, max:140, meat:true},
        {k:"fat",   emoji:"\ud83d\udc1f", name:"Mięso tłustsze",       desc:"udka ze skórą, wieprzowina, łosoś",     min:180, max:210, meat:true},
        {k:"carbs", emoji:"\ud83c\udf5a", name:"Mięso + węglowodany",  desc:"ryż, kasza, ziemniaki",                 min:130, max:150, meat:false},
        {k:"veg",   emoji:"\ud83e\udd55", name:"Mięso + warzywa",      desc:"marchew, cukinia, dynia",               min:90,  max:110, meat:false}
      ];

      function fmtNum(n, dec){
        dec = dec || 0;
        return n.toLocaleString("pl-PL", {minimumFractionDigits:dec, maximumFractionDigits:dec});
      }
      function g(n){ return fmtNum(Math.round(n)) + " g"; }
      function gRange(a, b){
        var lo = Math.round(a / 5) * 5, hi = Math.round(b / 5) * 5;
        return lo === hi ? g(lo) : fmtNum(lo) + "\u2013" + fmtNum(hi) + " g";
      }

      var __rcSeq = 0;
      function init(root){
        var gid = "rc-type-" + (++__rcSeq);
        var $  = function(s){ return root.querySelector(s); };
        var $$ = function(s){ return Array.prototype.slice.call(root.querySelectorAll(s)); };

        /* --- karty wyboru (typ psa, sposób karmienia, proporcja, domowe) --- */
        function cards(host, list, group, attr, checkedIndex){
          list.forEach(function(t, i){
            var lab = document.createElement("label");
            lab.className = "rc-opt" + (i === checkedIndex ? " is-on" : "");
            var input = document.createElement("input");
            input.type = "radio";
            input.name = group;
            input.value = String(t.k !== undefined ? t.k : t.v);
            input.setAttribute(attr, "");
            if(i === checkedIndex) input.checked = true;
            var wrap = document.createElement("span");
            wrap.className = "rc-opt-in";
            if(t.emoji){
              var em = document.createElement("span");
              em.className = "rc-opt-emoji";
              em.setAttribute("aria-hidden", "true");
              em.textContent = t.emoji;
              wrap.appendChild(em);
            }
            var txt = document.createElement("span");
            txt.className = "rc-opt-txt";
            var nm = document.createElement("span");
            nm.className = "rc-opt-name";
            nm.textContent = t.name;
            var ds = document.createElement("span");
            ds.className = "rc-opt-desc";
            ds.textContent = t.desc;
            txt.appendChild(nm); txt.appendChild(ds);
            wrap.appendChild(txt);
            lab.appendChild(input); lab.appendChild(wrap);
            host.appendChild(lab);
          });
        }

        cards($("[data-types]"),  TYPES,  gid,               "data-in-type",  4);
        cards($("[data-feeds]"),  FEEDS,  gid + "-feed",     "data-in-feed",  0);
        cards($("[data-shares]"), SHARES, gid + "-share",    "data-in-share", 0);
        cards($("[data-homes]"),  HOMES,  gid + "-home",     "data-in-home",  0);

        function picked(attr, list){
          var on = $$("[" + attr + "]").filter(function(r){ return r.checked; })[0];
          var v = on ? on.value : null;
          for(var i=0;i<list.length;i++){
            var key = String(list[i].k !== undefined ? list[i].k : list[i].v);
            if(key === v) return list[i];
          }
          return list[0];
        }

        var slider = $("[data-in-weight]"), num = $("[data-in-weight-num]");
        var kcalDry = $("[data-in-kcal]"), kcalWet = $("[data-in-kcal-wet]"), kcalHome = $("[data-in-kcal-home]");
        var bagIn = $("[data-in-bag]"), priceIn = $("[data-in-price]");
        var result = $("[data-result]");
        var demandPanel = $("[data-demand]");
        var demandBtn = $("[data-demand-btn]");
        var demandOk = $("[data-demand-ok]");
        var meals = 2, shown = false;
        var disp = {kcal:0, grams:0};
        var rafs = {};


        function animate(key, el, to, dec){
          if(rafs[key]) cancelAnimationFrame(rafs[key]);
          var from = disp[key] || 0, start = null, dur = 400;
          if(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches){
            disp[key] = to; el.textContent = fmtNum(to, dec); return;
          }
          function step(ts){
            if(start === null) start = ts;
            var p = Math.min(1, (ts - start) / dur);
            var e = 1 - Math.pow(1 - p, 3);
            el.textContent = fmtNum(from + (to - from) * e, dec);
            if(p < 1) rafs[key] = requestAnimationFrame(step);
            else { disp[key] = to; el.textContent = fmtNum(to, dec); }
          }
          rafs[key] = requestAnimationFrame(step);
        }

        var scope = root.closest("[data-rc-scope]") || root.parentNode;

        function publish(params, stageName){
          if(!scope || !scope.setAttribute) return;
          try { scope.setAttribute("data-rc-params", JSON.stringify(params)); } catch(e){}
          var slots = scope.querySelectorAll("[data-rc-stage-name]");
          for(var i=0;i<slots.length;i++) slots[i].textContent = stageName;
          scope.setAttribute("data-rc-stage", stageName);
        }

        /* pola tekstowe z przecinkiem — polski zapis dziesiętny */
        function readNum(el){
          if(!el) return null;
          var v = parseFloat(String(el.value).replace(",", ".").replace(/\s/g, ""));
          return isNaN(v) ? null : v;
        }
        function showW(v){ return String(v).replace(".", ","); }

        function applyVisibility(feed, second){
          var need = {
            dry:  feed.parts.indexOf("dry") !== -1,
            wet:  feed.parts.indexOf("wet") !== -1,
            home: feed.parts.indexOf("home") !== -1,
            mix:  feed.parts.length > 1
          };
          $$("[data-need]").forEach(function(el){ el.hidden = !need[el.getAttribute("data-need")]; });
          if(need.mix && second) $("[data-second-name]").textContent = PART[second].short;
        }

        function paintSlider(){
          var mn = parseFloat(slider.min), mx = parseFloat(slider.max);
          var p = ((parseFloat(slider.value) - mn) / (mx - mn)) * 100;
          slider.style.background =
            "linear-gradient(90deg, var(--rc-accent) 0 " + p.toFixed(2) + "%, var(--rc-track) " + p.toFixed(2) + "% 100%)";
        }

        function render(){
          paintSlider();

          var w = parseFloat(slider.value);
          var t = picked("data-in-type", TYPES);
          var feed = picked("data-in-feed", FEEDS);
          var share = picked("data-in-share", SHARES);
          var home = picked("data-in-home", HOMES);

          /* --- 6. opcja: wszystkie trzy → zbieranie zapotrzebowania --- */
          if(feed.demand){
            result.hidden = true;
            demandPanel.hidden = false;
            demandPanel.classList.add("is-in");
            applyVisibility({parts:["dry","wet","home"], demand:true}, "wet");
            return;
          }
          demandPanel.hidden = true;
          result.hidden = false;

          var second = feed.parts.length > 1 ? feed.parts[1] : null;
          applyVisibility(feed, second);

          var rer = 70 * Math.pow(w, 0.75);
          var mer = rer * t.f;

          var dryK = readNum(kcalDry) || 350;
          var wetK = readNum(kcalWet) || 90;
          var homeK = readNum(kcalHome);

          /* podział DZIENNYCH KALORII, nie gramów */
          var shares = {};
          if(feed.parts.length === 1) shares[feed.parts[0]] = 1;
          else {
            shares[feed.parts[0]] = 1 - share.v / 100;
            shares[feed.parts[1]] = share.v / 100;
          }

          var rows = [];
          feed.parts.forEach(function(p){
            var kcal = mer * shares[p];
            var row = {part:p, kcal:kcal, share:shares[p]};
            if(p === "dry"){ row.min = row.max = kcal / dryK * 100; row.src = fmtNum(dryK) + " kcal/100 g"; }
            else if(p === "wet"){ row.min = row.max = kcal / wetK * 100; row.src = fmtNum(wetK) + " kcal/100 g"; }
            else if(homeK){ row.min = row.max = kcal / homeK * 100; row.src = fmtNum(homeK) + " kcal/100 g"; }
            else {
              row.min = kcal / home.max * 100;
              row.max = kcal / home.min * 100;
              row.src = home.min + "\u2013" + home.max + " kcal/100 g";
            }
            rows.push(row);
          });

          var single = rows.length === 1;
          var isRange = single && Math.round(rows[0].min) !== Math.round(rows[0].max);

          animate("kcal", $("[data-kcal]"), Math.round(mer));
          $("[data-grams-cell]").hidden = !single;
          $("[data-grams-div]").hidden = !single;

          if(single){
            if(isRange){
              $("[data-grams]").textContent = gRange(rows[0].min, rows[0].max).replace(" g", "");
              disp.grams = Math.round((rows[0].min + rows[0].max) / 2);
            } else {
              animate("grams", $("[data-grams]"), Math.round(rows[0].min));
            }
            $("[data-grams-unit]").textContent = feed.parts[0] === "home" ? "g domowego jedzenia" : "g karmy dziennie";
            $("[data-headline]").textContent =
              PART[feed.parts[0]].short + " \u00b7 " + rows[0].src + " \u00b7 współczynnik " + String(t.f).replace(".", ",") + " \u00d7 RER";
          } else {
            $("[data-headline]").textContent =
              "podział na składniki poniżej \u00b7 współczynnik " + String(t.f).replace(".", ",") + " \u00d7 RER";
          }

          /* rozbicie na składniki */
          var partsBox = $("[data-parts]");
          partsBox.innerHTML = "";
          partsBox.hidden = single;
          if(!single){
            rows.forEach(function(r){
              var row = document.createElement("div");
              row.className = "rc-part";
              var l = document.createElement("div");
              l.className = "rc-part-l";
              var n = document.createElement("div");
              n.className = "rc-part-n";
              n.textContent = PART[r.part].name;
              var sub = document.createElement("div");
              sub.className = "rc-part-s";
              sub.textContent = Math.round(r.share * 100) + "% dziennych kalorii \u00b7 " +
                fmtNum(Math.round(r.kcal)) + " kcal \u00b7 " + r.src;
              l.appendChild(n); l.appendChild(sub);
              var rgt = document.createElement("div");
              rgt.className = "rc-part-r";
              var v = document.createElement("div");
              v.className = "rc-part-v";
              v.textContent = Math.round(r.min) === Math.round(r.max) ? g(r.min) : gRange(r.min, r.max);
              var vs = document.createElement("div");
              vs.className = "rc-part-vs";
              vs.textContent = "\u2248 " + g((r.min + r.max) / 2 / meals) + " na posiłek";
              rgt.appendChild(v); rgt.appendChild(vs);
              row.appendChild(l); row.appendChild(rgt);
              partsBox.appendChild(row);
            });
          }

          /* miska */
          var totalMid = 0;
          rows.forEach(function(r){ totalMid += (r.min + r.max) / 2; });
          var per = totalMid / meals;
          $("[data-portion]").textContent = "\u2248 " + g(per) + " na posiłek";
          $("[data-portion-sub]").textContent = single
            ? meals + "\u00d7 dziennie \u00b7 łącznie " + (isRange ? gRange(rows[0].min, rows[0].max) : g(rows[0].min)) + " (" + fmtNum(Math.round(mer)) + " kcal)"
            : meals + "\u00d7 dziennie \u00b7 suma wszystkich składników, rozbicie wyżej";
          var fill = Math.max(.08, Math.min(1, per / 300));
          var h = 27 * fill;
          var fillRect = $("[data-fill]");
          fillRect.setAttribute("y", String(43 - h));
          fillRect.setAttribute("height", String(h));

          /* ostrzeżenia */
          var warns = [];
          var usesHome = feed.parts.indexOf("home") !== -1;
          if(usesHome && home.meat){
            warns.push({hard:true, text:"Dieta oparta na samym mięsie mięśniowym zawiera dużo fosforu i praktycznie zero wapnia. Utrzymywana długo odwraca proporcję wapnia do fosforu i organizm zaczyna pobierać wapń z kośćca \u2014 u szczeniąt prowadzi to do deformacji kości i złamań. Taki jadłospis trzeba uzupełnić wapniem oraz mikroelementami, najlepiej po konsultacji z lekarzem weterynarii."});
          } else if(usesHome){
            warns.push({text:"Dieta domowa wymaga zbilansowania \u2014 dopasowanie kalorii to dopiero połowa sprawy. Kluczowe są wapń, witamina D, cynk i kwasy omega-3. Skład warto ustalić z lekarzem weterynarii lub dietetykiem zwierzęcym."});
          }
          if(!single){
            warns.push({text:"Powyższe gramatury sumują się już do pełnego dziennego zapotrzebowania. Najczęstszy błąd przy karmieniu mieszanym to pełna porcja karmy suchej i mokra „na wierzch” \u2014 to nie mieszanie, a nadwyżka kalorii."});
          }
          if(per > 400 && meals < 3){
            warns.push({text:"Przy tak dużej porcji jednorazowej rozważ podział na 3 posiłki. Duże psy karmione raz dziennie są bardziej narażone na rozszerzenie i skręt żołądka (GDV)."});
          }
          if(t.k === "szcz04" && meals < 3){
            warns.push({text:"Szczeniak do 4. miesiąca życia powinien jeść 3\u20134 razy dziennie \u2014 jego żołądek nie pomieści całej porcji naraz, a długie przerwy grożą spadkiem poziomu cukru."});
          }
          if(t.k === "dieta"){
            warns.push({text:"Przy diecie redukcyjnej podstaw wagę docelową psa, a nie aktualną. Inaczej „dieta” utrwali obecną nadwagę."});
          }
          var warnBox = $("[data-warns]");
          warnBox.innerHTML = "";
          warns.slice(0, 2).forEach(function(wr){
            var d = document.createElement("div");
            d.className = "rc-warn" + (wr.hard ? " rc-warn--hard" : "");
            d.textContent = wr.text;
            warnBox.appendChild(d);
          });

          /* kafelki */
          $("[data-treats]").textContent = fmtNum(Math.round(mer * 0.1)) + " kcal";
          var dryless = feed.parts.indexOf("dry") === -1;
          $("[data-water]").textContent = dryless
            ? fmtNum(Math.round(w * 25)) + "\u2013" + fmtNum(Math.round(w * 40)) + " ml"
            : fmtNum(Math.round(w * 50)) + "\u2013" + fmtNum(Math.round(w * 60)) + " ml";
          $("[data-water-sub]").textContent = dryless
            ? "mniej niż przy karmie suchej \u2014 dużą część wody pies dostaje z jedzeniem"
            : "przy karmie suchej; przy mokrej i domowej pies wypije mniej";
          $("[data-rer]").textContent = fmtNum(Math.round(rer)) + " kcal";

          /* koszt \u2014 tylko karma sucha */
          var dryRow = null;
          rows.forEach(function(r){ if(r.part === "dry") dryRow = r; });
          var bag = parseFloat(bagIn.value), price = parseFloat(priceIn.value);
          var cost = $("[data-cost]");
          var costMonthly = "";
          if(dryRow && !isNaN(bag) && bag > 0){
            cost.hidden = false;
            var days = (bag * 1000) / dryRow.min;
            $("[data-bag-days]").textContent = fmtNum(Math.round(days)) + " dni";
            $("[data-bag-sub]").textContent = "opakowanie " + fmtNum(bag, bag % 1 ? 1 : 0) + " kg przy " + g(dryRow.min) + " dziennie";
            if(!isNaN(price) && price > 0){
              $("[data-cost-day]").textContent = fmtNum(price / days, 2) + " zł";
              $("[data-cost-month]").textContent = fmtNum((price / days) * 30, 2) + " zł";
              costMonthly = Math.round((price / days) * 30);
            } else {
              $("[data-cost-day]").textContent = "\u2014";
              $("[data-cost-month]").textContent = "\u2014";
            }
          } else {
            cost.hidden = true;
          }

          $("[data-comment]").textContent = t.note;

          publish({
            kalkulator: "karmienie_psa",
            waga_psa_kg: w,
            typ_psa: t.name,
            sposob_karmienia: feed.name,
            rodzaj_domowego: usesHome ? home.name : "",
            zapotrzebowanie_kcal: Math.round(mer),
            porcja_g_dziennie: Math.round(totalMid),
            koszt_miesieczny_zl: costMonthly
          }, t.name);

          if(!shown){ shown = true; requestAnimationFrame(function(){ result.classList.add("is-in"); }); }
        }

        slider.addEventListener("input", function(){ num.value = showW(slider.value); render(); });
        num.addEventListener("input", function(){
          var v = readNum(num);
          if(v !== null){ slider.value = Math.min(80, Math.max(1, v)); render(); }
        });
        num.addEventListener("blur", function(){
          var v = readNum(num);
          if(v === null) v = 25;
          v = Math.min(80, Math.max(1, Math.round(v * 2) / 2));
          num.value = showW(v); slider.value = v; render();
        });

        $$("input[type=radio]").forEach(function(r){
          r.addEventListener("change", function(){
            var grp = r.closest(".rc-options");
            if(grp) Array.prototype.forEach.call(grp.querySelectorAll(".rc-opt"), function(o){ o.classList.remove("is-on"); });
            var own = r.closest(".rc-opt");
            if(own) own.classList.add("is-on");
            render();
          });
        });

        [kcalDry, kcalWet, kcalHome, bagIn, priceIn].forEach(function(el){
          el.addEventListener("input", render);
        });

        $$(".rc-chip").forEach(function(c){
          c.addEventListener("click", function(){
            $$(".rc-chip").forEach(function(x){ x.classList.remove("is-on"); x.setAttribute("aria-pressed","false"); });
            c.classList.add("is-on"); c.setAttribute("aria-pressed","true");
            meals = parseInt(c.getAttribute("data-meals"), 10);
            render();
          });
        });

        /* --- przycisk zapotrzebowania --- */
        if(demandBtn) demandBtn.addEventListener("click", function(){
          if(window.dataLayer) window.dataLayer.push({event:"rola_calc_demand", rola_feature:"all_three_feeding"});
          demandBtn.hidden = true;
          if(demandOk) demandOk.hidden = false;
        });

        render();
      }

      var nodes = document.querySelectorAll("[data-rola-dog-food]");
      for(var i=0;i<nodes.length;i++){
        if(nodes[i].getAttribute("data-rc-init")) continue;
        nodes[i].setAttribute("data-rc-init","1");
        init(nodes[i]);
      }
    })();
  }
  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  // ponowna inicjalizacja po zmianach w Edytorze motywu Shopify
  document.addEventListener("shopify:section:load", boot);
})();
